// 设备维修
<template>
  <div style="position: relative">
    <el-form
      ref="formSysPost"
      :model="formSysPost"
      label-width="100px"
      :size="defaultFormItemSize"
      label-position="right"
      @submit.native.prevent
    >
      <filter-box :item-width="350">
        <el-form-item label="维护单：" prop="maintain_no">
          <el-input
            class="filter-item"
            v-model="tableParams.maintain_no"
            size="small"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="设备编码:" prop="sn">
          <el-input
            class="filter-item"
            v-model="tableParams.sn"
            size="small"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="设备名称：" prop="name">
          <el-input
            class="filter-item"
            v-model="tableParams.name"
            size="small"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="维护状态：" prop="status">
          <el-select
            class="filter-item"
            v-model="tableParams.status"
            clearable
            filterable
            size="small"
          >
            <el-option key="OK" label="OK" value="OK"> </el-option>
            <el-option key="NG" label="NG" value="NG"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="维护日期：" prop="times">
          <date-range
            class="filter-item"
            v-model="tableParams.times"
            :clearable="true"
            :allowTypes="['day']"
            align="left"
            range-separator="-"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd HH:mm:ss"
          />
        </el-form-item>
        <el-button
          slot="operator"
          type="default"
          :plain="true"
          size="mini"
          @click="onReset"
        >
          重置
        </el-button>
        <el-button
          slot="operator"
          type="primary"
          :plain="true"
          size="mini"
          @click="onSearch()"
        >
          查询
        </el-button>
        <el-button
          slot="operator"
          type="primary"
          size="small"
          @click="addItem()"
        >
          新建
        </el-button>
      </filter-box>
    </el-form>
    <el-row>
      <el-col :span="24">
        <Table
          :tableData="tableData"
          :loading="false"
          :operateWidth="160"
          :tableHeader="tableHeader"
          :pagination="pagination"
          @pagination="changePagination"
          :slotArr="slotArr"
        >
          <!-- table 操作栏 -->
          <template slot="operation" slot-scope="scope">
            <el-button @click.stop="editItem(scope.row)" type="text">
              详情
            </el-button>
            <el-button
              class="table-btn delete"
              @click.stop="deleteItem(scope.row)"
              type="text"
            >
              删除
            </el-button>
          </template>
        </Table>
      </el-col>
    </el-row>

    <!-- <div class="dia_box" v-if="dialogVisible">
      <AddOrEdit
        @diaClose="diaClose"
        @onAdd="onAdd"
        @onUpdate="onUpdate"
        :row="row"
      />
    </div> -->
    <el-dialog
      :title="title === 1 ? '新增' : '详情'"
      :visible.sync="dialogVisible"
      @close="diaClose"
      width="80%"
      top="0"
      class="dia_box"
    >
      <AddOrEdit
        v-if="dialogVisible"
        @diaClose="diaClose"
        @onAdd="onAdd"
        :row="row"
      />
    </el-dialog>
  </div>
</template>

<script>
/* eslint-disable-next-line */
import rules from "@/utils/validate.js";
import {
  DropdownWidget,
  TableWidget,
  UploadWidget,
  ChartWidget,
} from "@/utils/widget.js";
import AddOrEdit from "./indexInfo.vue";
import Table from "../../../components/MyTable/index.vue";

export default {
  name: "LabelModel",
  props: {},
  components: {
    AddOrEdit,
    Table,
  },
  // mixins: [uploadMixin, statsDateRangeMixin, cachePageMixin],
  data() {
    return {
      showSearch: true,
      slotArr: [
        { slotname: "headBox" },
        { slotname: "searchBox", className: "search_box" },
        { slotname: "btnBox", className: "" },
      ],

      tableData: [],

      tableHeader: [],
      // table 筛选条件
      tableParams: {
        maintain_no: null,
        name: null,
        status: null,
        sn: null,
        times: [],
      },
      tableSearch: [],

      pagination: {
        size: 10,
        total: 0,
        page: 1,
      },

      formSysPost: {
        formFilter: {
          postName: undefined,
        },
        formFilterCopy: {
          postName: undefined,
        },
        sysPost: {
          impl: new TableWidget(
            this.loadSysPostWidgetData,
            this.loadSysPostVerify,
            true,
            false,
            "level",
            1
          ),
        },
        isInit: false,
      },
      typeObj: {
        1: "原材料",
        2: "模具",
        3: "成品",
      },
      modelTypeArr: [
        { label: "原材料", value: 1 },
        { label: "模具", value: 2 },
        { label: "成品", value: 3 },
      ],

      dialogVisible: false,
      title: 1, // 1、新增 2、编辑 3、详情
      row: {},
    };
  },
  methods: {
    // 筛选 页数为 1
    onSearch() {
      this.pagination.page = 1;
      this.getTableData();
    },
    // 页数切换
    changePagination(val) {
      this.pagination = {
        ...this.pagination,
        ...val,
      };
      this.getTableData();
    },
    async getTableData() {
      let filterDtoList = [];
      for (const key in this.tableParams) {
        let val = this.tableParams[key];
        if (val && key === "times" && val.length > 0) {
          filterDtoList.push({
            columnName: "maintain_date",
            columnValueStart: val[0],
            columnValueEnd: val[1],
            filterType: 2,
            tableName: "zz_device_maintain_history",
          });
        } else if (val && key !== "times") {
          filterDtoList.push({
            columnName: key,
            columnValue: val,
            filterType: key === "sn" ? 3 : 1,
            tableName: "zz_device_maintain_history",
          });
        }
      }

      let params = {
        datasourceId: "1639883438855032832",
        pageParam: {
          pageNum: this.pagination.page,
          pageSize: this.pagination.size,
        },
        filterDtoList: filterDtoList,
      };
      let httpCall = this.doUrl(
        "/admin/online/onlineOperation/listByDatasourceId/" +
          "dsDeviceMaintainHistory",
        "post",
        params
      );
      httpCall.then((res) => {
        console.log("res.data", res.data);
        this.tableData = res.data.dataList;
        this.pagination.total = res.data.totalCount;
      });
    },
    addItem() {
      this.row = {};
      this.title = 1;
      this.dialogVisible = true;
    },
    onAdd(Obj) {
      let params = {
        datasourceId: "1639883438855032832",
        masterData: Obj.masterData || {
          device_id: 95,
          status: "OK",
          maintain_date: "2023-10-12 09:58:57",
          maintain_by: "1698651623493996544",
          device_type: 4,
          model: "JW31-400",
          name: "冲床",
          sn: "ZQ-CY-008",
        },
        slaveData: {
          "1639883742426173440": Obj.arr || [
            { item_id: 13, type: "BY", code: "013" },
            { item_id: 14, type: "BY", code: "014" },
            { item_id: 15, type: "BY", code: "015" },
            { item_id: 16, type: "BY", code: "016" },
          ],
        },
      };
      let httpCall = this.doUrl(
        "/admin/online/onlineOperation/addDatasource/" +
          "dsDeviceMaintainHistory",
        "post",
        params
      );
      httpCall.then((res) => {
        console.log("新增成功 res.data", res.data);
        this.dialogVisible = false;
        this.getTableData();
      });
    },
    // 重置
    onReset() {
      this.tableParams = {};
      this.getTableData();
    },
    diaClose() {
      this.dialogVisible = false;
      setTimeout(() => {
        this.title = null;
      }, 100);
    },
    editItem(row) {
      this.row = row;
      this.title = 2;
      this.dialogVisible = true;
    },
    // 删除
    async onDel(row) {
      let params = {
        dataId: row.id,
        datasourceId: "1639883438855032832",
      };
      let httpCall = this.doUrl(
        "/admin/online/onlineOperation/deleteDatasource/" +
          "dsDeviceMaintainHistory",
        "post",
        params
      );
      httpCall.then((res) => {
        this.$message({
          message: "删除成功",
          type: "success",
        });
        this.getTableData();
      });
    },

    deleteItem(row) {
      this.$alert("确定删除该条数据吗", "提示", {
        confirmButtonText: "确定",
        callback: (action) => {
          if (action == "confirm") {
            this.onDel(row);
          }
        },
      });
    },
  },
  mounted() {
    this.tableHeader = [
      { label: "序号", prop: "index" },
      { label: "维护单", prop: "maintain_no" },
      { label: "设备名称", prop: "name" },
      { label: "设备编码", prop: "sn" },
      { label: "规格型号", prop: "model" },
      {
        label: "设备类型",
        prop: "device_type",
        render: (h, params) => {
          return <p>{params.row.device_type__DictMap.name}</p>;
        },
      },
      {
        label: "维护状态",
        prop: "status",
        render: (h, params) => {
          return <p>{params.row.status__DictMap.name}</p>;
        },
      },
      { label: "维护日期", prop: "maintain_date" },
      {
        label: "维护人",
        prop: "maintain_by",
        render: (h, params) => {
          return <p>{params.row.maintain_by__DictMap.name}</p>;
        },
      },
      { label: "操作", slotname: "operation", width: "120" },
    ];

    this.getTableData();
  },
  activated() {
    this.getTableData();
  },
  watch: {},
};
</script>

<style lang="scss" scoped>
.dia_box {
  width: 100%;
  height: 100vh;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 1001;
  background: rgba(0, 0, 0, 0.5);

  // ::v-deep {
  //   .el-dialog {
  //     width: 100%;
  //     height: 100%;
  //   }
  // }
}
</style>
